import React, {Component} from "react";
import { Row, Col, Button, FormGroup, Label, Input } from "reactstrap";
import { inject, observer } from "mobx-react";
import FormInput from "../../../../comum/components/FormInput";
import Card from "../../../../comum/components/Card";
import FormSelect from "../../../../comum/components/FormSelect";
import { IconeDelete, IconeCopiar } from "../../../../comum/components/Icones";
import RadiobuttonGroup from '../../../../comum/components/RadiobuttonGroup';
import RetiradaDevolucaoStore from "../stores/RetiradaDepotDevolucaoStore";

@inject("store")
@observer
export class RetiradaDepotDevolucao extends Component {
    constructor(props) {
        super(props);
        this.parametrosStore = this.props.store.parametrosStore;
        
        this.agendamentoController = this.props.agendamentoController;
        this.controller = new RetiradaDevolucaoStore();
    };

    componentDidMount() {       
        if (!this.agendamentoController.isEditar){
            this.agendamentoController.adicionarDevolucao();
            // this.agendamentoController.adicionarRetirada();

        } else {
            if(this.agendamentoController.dadosAgendamento.listaBookings
                && this.agendamentoController.dadosAgendamento.listaBookings.length > 0
                && this.agendamentoController.dadosAgendamento.listaBookings[0].containers){

                this.agendamentoController.dadosAgendamento.listaBookings[0].containers.map((cntr, x) => {
                    this.controller.carregarDadosBooking(cntr.NumBooking ? cntr.NumBooking : "", x, this.agendamentoController.dadosAgendamento, false)
                    this.controller.carregarTiposCntrPorBooking(cntr.NumBooking ? cntr.NumBooking : "", x, this.agendamentoController.dadosAgendamento, false)})
            }
        }
    };

    botaoAdicionar(titulo) {
        return <Button onClick={ this.handleAdicionarClick } className="btn-com-bordas-primary">{titulo}</Button>;
    };

    handleAdicionarClick = () => {
        this.agendamentoController.adicionarDevolucao(); 
        this.controller.adicionarNovoParceiro();
    }
    
    handleRemoverClick = (index) => {
        this.agendamentoController.removerRetiradaDepot(index);
        this.controller.removerItemRetirada(index);
        this.controller.removerParceiro(index);
    }
    
    handleCopyClick = (index) => {
        this.agendamentoController.copiarRetiradaDepot(index);
        // this.controller.removerItemRetirada(index);]
        // console.log(index);
    }

    campoCntr(dado, md) {
        return this.agendamentoController.atualizaDevolucoes && <FormInput  sm={12} xs={12} md={md} titulo="Num. container"
                            bloqueado={ false }
                            objeto={ this.agendamentoController.dadosAgendamento }
                            dado={ dado }
                            onChange={ (event) => this.handleChangeCntr(dado, event) }  
                />;
    };
    
    campoCnpj(dado, md, index) {
        return this.agendamentoController.atualizaDevolucoes && <FormInput  sm={12} xs={12} md={md} titulo="CNPJ parceiro"
                            bloqueado={ false }
                            objeto={ this.agendamentoController.dadosAgendamento }
                            dado={ dado }
                            onChange={ (event) => this.handleChangeCnpj(dado, event, index) }  
                />;
    };

    campoTipoCntr(dado, md) {
        return this.agendamentoController.atualizaDevolucoes && <FormSelect  xs={12} sm={12} md={md} titulo="Tipo cntr"
                            bloqueado={ false }
                            itens={ this.controller.tiposCntr }
                            objeto={ this.agendamentoController.dadosAgendamento }
                            dado={ dado }
                            itensValor="Iso" itensLabel="IsoTipoCntr"
                            onChange={ (event) => this.handleChangeTipoCntr(dado, event) } 
                />;
    };
    campoNavioViagem(dado, md, index) {
        return this.agendamentoController.atualizaDevolucoes && <FormSelect  xs={12} sm={12} md={md} titulo="Navio / Viagem"
        bloqueado={ false }
        itens={ this.controller.listaOperacoes[index] }
        objeto={ this.agendamentoController.dadosAgendamento }
        dado={ dado }
        itensValor="CodTipoCntr" itensLabel="CodTipoCntr"
        onChange={ (event) => this.handleChangeNavioViagem(dado, event, index) } 
        />;
    };

    campoArmador(dado, md) {
        return this.agendamentoController.atualizaDevolucoes && <FormSelect  xs={12} sm={12} md={md} titulo="Armador"
                            bloqueado={ false }
                            itens={ this.controller.listaArmadores }
                            objeto={ this.agendamentoController.dadosAgendamento }
                            dado={ dado }
                            itensValor="ArmId" itensLabel="ApelidoArmador"
                            onChange={ (event) => this.handleChangeArmador(dado, event) } 
                />;
    };

    handleChangeCntr = (dado, event) => {
        this.agendamentoController.setDadosAgendamento(dado, event);
        
        this.agendamentoController.atualizaDevolucoes = false;
        setTimeout(function () {
            this.agendamentoController.atualizaDevolucoes = true;
        }.bind(this), 1)
    };
    
    handleChangeCnpj = (dado, event, index) => {
        this.controller.carregarCnpjParceiro(event.target.value, index);
        this.agendamentoController.setDadosAgendamento(dado, event);
        
        this.agendamentoController.atualizaDevolucoes = false;
        setTimeout(function () {
            this.agendamentoController.atualizaDevolucoes = true;
        }.bind(this), 1)
    };

    handleChangeTipoCntr = (dado, event) => {
        this.agendamentoController.atualizaDevolucoes = false;
        this.agendamentoController.setDadosAgendamento(dado, event);
        setTimeout(function () {
            this.agendamentoController.atualizaDevolucoes = true;
        }.bind(this), 1)
    };

    handleChangeNavioViagem = (dado, event, index) => {
        console.log(dado, event, index);

        // let item = this.controller.tiposCntr[index].filter(item => item.CodTipoCntr === event.value);
    
        // if("S" !== item[0].FlgRefrigCntr){
        //     this.agendamentoController.listaMensagens = ["Agendamento somente permitido para Reefers. Por favor, selecione um Tipo compatível."];
        // } else {
        //     //this.controller.qtdDisponivel[index] = item[0].Quantidade;
        //     //this.controller.isReefer[index] = "S" === item[0].FlgRefrigCntr;
        //     //this.controller.carregarDadosTipoCntr(item[0].BookingCntrId, index);
        //     this.agendamentoController.setDadosAgendamento(dado, event);
        // }        
        
        // this.agendamentoController.atualizaDevolucoes = false;
        // setTimeout(function () {
        //     this.agendamentoController.atualizaDevolucoes = true;
        // }.bind(this), 1)
    };

    handleChangeArmador = (dado, event) => {
        this.agendamentoController.setDadosAgendamento(dado, event);
        this.agendamentoController.atualizaDevolucoes = false;
        setTimeout(function () {
            this.agendamentoController.atualizaDevolucoes = true;
        }.bind(this), 1)
    };

    cardVazioImp(titulo) {
       
            return <div>
                <Row>
                    <Col>
                        <h2>{ titulo }</h2>
                    </Col>
                    { !this.agendamentoController.isEditar && this.botaoAdicionar("Novo") }                    
                </Row>
                <Row>
                    { 
                     this.agendamentoController.dadosAgendamento.listaBookings
                        && this.agendamentoController.dadosAgendamento.listaBookings.length > 0
                        && this.agendamentoController.dadosAgendamento.listaBookings[0].containers
                        && this.agendamentoController.dadosAgendamento.listaBookings[0].containers.map((cntr, x) =>
                            <Col className="area-form card-form" xl={12} key={x}>
                                <Card>
                                    <Row>
                                        { this.campoCntr(`listaBookings[0].containers[${x}].CodCntr`, 4) }
                                        { this.campoTipoCntr(`listaBookings[0].containers[${x}].CdTipoCntr`, 4) }
                                        {/* { this.campoNavioViagem(`listaBookings[0].containers[${x}].VesselvisitId`, 4, x) }  */}
                                        { this.campoArmador(`listaBookings[0].containers[${x}].ArmIdDepot`, 4) }
                                        { this.campoCnpj(`listaBookings[0].containers[${x}].CnpjCliente`, 4, x)}
                                        <Col sm={12} xs={12} md={4}>
                                            <Label>CNPJ parceiro</Label>
                                            <Input disabled={true} value={this.controller.cnpjParceiro[x]} />
                                        </Col>
                                    </Row>
                                </Card>
                                { !this.agendamentoController.isEditar
                                    && <IconeDelete className="icone-delete-borda" tamanho="3x" onClick={ () =>  this.handleRemoverClick(x) } /> }
                                    <IconeCopiar className="icone-copia-borda" tamanho="3x" onClick={ () =>  this.handleCopyClick(x) } />
                            </Col>
                    )}
                </Row>                
            </div>
    };

    

    formDepot() {
        switch (this.props.tipoAgenda) {
            case "DDI":
                return this.cardVazioImp("DEPOT - Devolução de Importação");
            default:
                break;
        }
    };

    render() {
        return (
            <div>
                { (this.agendamentoController.terminal === "SSA") && this.formDepot() }
            </div>
        );
    };
}



// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/retirada-containers-devolucao/components/RetiradaDepotDevolucao.js